
import emailjs from '@emailjs/browser';
import { EMAIL_CONFIG } from '@/config/email';

// Initialize EmailJS
emailjs.init(EMAIL_CONFIG.PUBLIC_KEY);

// Email service utility voor het verzenden van form data naar info@classbuddy.nl
export const sendEmail = async (templateParams) => {
  try {
    console.log('Sending email with EmailJS...', templateParams);

    // Send email via EmailJS met jouw template parameters
    const response = await emailjs.send(
      EMAIL_CONFIG.SERVICE_ID,
      EMAIL_CONFIG.TEMPLATE_ID,
      templateParams
    );

    console.log('Email sent successfully:', response);
    return { success: true, response };

  } catch (error) {
    console.error('EmailJS error:', error);
    
    // Better error handling
    const errorMessage = error?.text || error?.message || 'Unknown error occurred';
    return { 
      success: false, 
      error: errorMessage,
      isConfigError: errorMessage.includes('not found') || errorMessage.includes('Invalid')
    };
  }
};

console.log('✅ EmailJS is configured and ready!');
